module.exports = __webpack_public_path__ + "static/media/Timer_COLLECT@3x.adcf6a29.png";